import React from 'react';
import Footer from '../components/common/Footer';
import './AboutPage.css';

const STATS = [
  { num: '38', label: 'Districts covered' },
  { num: '6', label: 'Services offered' },
  { num: '₹0', label: 'Hidden charges' },
  { num: '24/7', label: 'Availability' },
];

const STORY = [
  { year: '2025', title: 'ZilaCab founded', body: 'Platform launched with one-way taxi service across Patna and nearby districts. First fleet partner onboarded.' },
  { year: '2025 — Q2', title: 'Six services live', body: 'TaxiPool, Hourly Rental, Bihar Tours, Wedding Fleet, and House Shifting all launched on the platform.' },
  { year: '2025 — Q3', title: 'Pan-Bihar expansion', body: 'Coverage extended to all 38 Bihar districts. Driver network grows to 100+ verified partners.' },
  { year: '2026', title: 'Mobile app launch', body: 'Android app on Play Store. Live GPS tracking, UPI payments, and driver rating system.' },
];

const VALUES = [
  { num: '01', title: 'Transparency first', body: 'Every fare is shown before confirmation. No hidden charges. No surprise bills. If a surcharge applies, we tell you why — before you pay.' },
  { num: '02', title: 'Bihar-first thinking', body: "We build for Bihar's specific needs — intercity distances, rural routes, wedding seasons, festival travel. Not a generic platform copy-pasted from a metro city." },
  { num: '03', title: 'Driver partnership', body: 'Our drivers earn more with ZilaCab than going solo. We fill their return trips, pay on time every Sunday, and treat them as partners — not just contractors.' },
];

const AboutPage = () => (
  <div className="about-page">
    <section className="about-hero">
      <div className="about-hero-left">
        <div className="section-eyebrow on-dark">Our story</div>
        <h1>Bihar ke liye,<em>Bihar se.</em></h1>
        <p>ZilaCab was built to solve a simple problem — getting from one Bihar city to another was expensive, unreliable, and opaque. We changed that. One honest trip at a time.</p>
      </div>
      <div className="about-hero-right">
        <div className="stat-grid">
          {STATS.map((s) => (
            <div key={s.label} className="stat-cell">
              <div className="stat-num">{s.num}</div>
              <div className="stat-lbl">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="story-section">
      <div className="story-inner">
        <div className="story-left">
          <div className="section-eyebrow">Why ZilaCab exists</div>
          <h2>Bihar deserves better travel.</h2>
          <p>For decades, Bihar's intercity travel was dominated by unorganised taxi operators — no fixed prices, no accountability, no receipts. Passengers paid whatever the driver demanded.</p>
          <p>We built ZilaCab to change that. A platform where every fare is shown upfront, every driver is verified, and every customer gets a reference number and a confirmation call.</p>
          <p>We started with one-way taxi — because paying a return fare for a one-way trip is simply unfair. Then we added TaxiPool, tours, weddings, and house shifting. All with the same principle: honest prices, always.</p>
          <p style={{ marginBottom: 0 }}>ZilaCab is Bihar-first. Not a copy of Ola or Uber. Built for Bihar's roads, Bihar's distances, and Bihar's customers.</p>
        </div>
        <div>
          <div className="section-eyebrow">Our journey</div>
          {STORY.map((s) => (
            <div key={s.year} className="story-block">
              <div className="story-year">{s.year}</div>
              <h4>{s.title}</h4>
              <p>{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="values-section">
      <div className="values-inner">
        <div className="section-eyebrow">What we stand for</div>
        <h2 className="section-title">Our values</h2>
        <p className="section-sub">Three principles that drive every decision we make at ZilaCab.</p>
        <div className="values-grid">
          {VALUES.map((v) => (
            <div key={v.num} className="val-card">
              <div className="val-num">{v.num}</div>
              <h3>{v.title}</h3>
              <p>{v.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    <section className="team-section">
      <div className="team-inner">
        <div className="section-eyebrow">The team</div>
        <h2 className="section-title">Who built ZilaCab</h2>
        <p className="section-sub">A small team with a big belief — Bihar's transport problem has a solution.</p>
        <div className="team-card">
          <div className="team-avatar">ZC</div>
          <div className="team-info">
            <h3>Founder &amp; CEO</h3>
            <div className="team-role">ZilaCab · Patna, Bihar</div>
            <p>Built ZilaCab from scratch — technology, brand, and operations. Background in software engineering. Born and raised in Bihar. Deeply frustrated by how difficult and expensive intercity travel was, and decided to build the solution rather than wait for someone else to.</p>
            <div className="team-tags">
              <span className="tag-pill">Tech</span>
              <span className="tag-pill">Operations</span>
              <span className="tag-pill">Bihar</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
);

export default AboutPage;
